/**
 * @author 3173
 * @description 列表
 * @Date 2020/9/23
 */
import React from 'react';
import {connect} from 'dva';
import {templateConfig, reduxTemplateCofig} from './config'

import {framework_tool, utils_tool, component_tool} from "@/tool";
import {handleExport} from "./utils";

let {WizContainer, WizReduxTemplate} = framework_tool;
let {checkStrLength} = utils_tool;
let {WizBrowserExport} = component_tool;

class SeriesProgramList extends WizContainer {

  componentName = 'seriesProgramList';

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 15
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['name'] = checkStrLength(val['name'], len);
        });
      }
      f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '名称',
        field: 'name',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '分类',
        field: 'seriesCategoryName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '类型',
        field: 'typeStr',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '状态',
        field: 'stateName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '课程数量',
        field: 'programCount',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '关注人数',
        field: 'followCount',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '受众',
        field: 'scope',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true  },
        },
      },
      {
        headerName: '管理范围',
        field: 'scope1',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true  },
        },
      }

    ]
    if (o['success']) {
      let typeEnum = {0: '系列', 1: '课程组'}

      let data = o['data']
      let _data = []

      data.map(d => {
        d['typeStr'] = typeEnum[d.type]

        let _d = { ...d }
        let authData = d['authData']
        let managerAuthInfo = d['managerAuthInfo']
        let target1 = ''
        let target = ''
          if (authData && Object.keys(authData)) {
            if (authData['orgIds'] && authData['orgIds'].length) {
              target += ' 组织范围：'
              authData['orgIds'].forEach(org => {
                target += org['name'] + ','
              });
              target += '\n'
            }
            if (authData['positionIds'] && authData['positionIds'].length) {
              target += ' 岗位：'
              authData['positionIds'].forEach(org => {
                target += org['name'] + ','
              });
              target += '\n'
            }
            if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
              target += ' 岗位分类：'
              authData['positionCategoryIds'].forEach(org => {
                target += org['name'] + ','
              });
              target += '\n'
            }
            if (authData['personIds'] && authData['personIds'].length) {
              target += ' 指定人员：'
              authData['personIds'].forEach(org => {
                target += org['userName'] +'('+org['fullName'] +'),'
              });
              target += '\n'
            }
          }
          if (managerAuthInfo && Object.keys(managerAuthInfo)) {
            if (managerAuthInfo['orgIds'] && managerAuthInfo['orgIds'].length) {
              target1 += ' 组织范围：'
              managerAuthInfo['orgIds'].forEach(org => {
                target1 += org['name'] + ','
              });
              target1 += '\n'
            }
            if (managerAuthInfo['positionIds'] && managerAuthInfo['positionIds'].length) {
              target1 += ' 岗位：'
              managerAuthInfo['positionIds'].forEach(org => {
                target1 += org['name'] + ','
              });
              target1 += '\n'
            }
            if (managerAuthInfo['positionCategoryIds'] && managerAuthInfo['positionCategoryIds'].length) {
              target1 += ' 岗位分类：'
              managerAuthInfo['positionCategoryIds'].forEach(org => {
                target1 += org['name'] + ','
              });
              target1 += '\n'
            }
            if (managerAuthInfo['personIds'] && managerAuthInfo['personIds'].length) {
              target1 += ' 指定人员：'
              managerAuthInfo['personIds'].forEach(org => {
                target1 += org['userName'] +'('+org['fullName'] +'),'
              });
              target1 += '\n'
            }
          }
          _d['scope1'] = target1
          _d['scope'] = target
          _data.push(_d)
          return d
      })

      WizBrowserExport({
        title: '系列化课程信息',
        sheetName: '系列化课程信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '系列化课程信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  _handleFollowFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '学员姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '学员账户',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '用户类型',
        field: 'userType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '关注时间',
        field: 'followDate',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      let series = data['series']
      let seriesFollowList = data['seriesFollowList']
      let str = '系列化课程名称: ' + series['name']
        + '\n' + '课程数量: ' + (series['programCount'] ? series['programCount'] : 0)
        + '\n' + '关注人数: ' + (series['followCount'] ? series['followCount'] : 0)
        + '\n' + '分类: ' + series['seriesCategoryName']
      seriesFollowList.forEach(e => {
        e['userType'] === 0 ? e['userType'] = '学员' :
          e['userType'] === 1 ? e['userType'] = 'SGM总部' :
            e['userType'] === 2 ? e['userType'] = 'SGM区域' :
              e['userType'] === 3 ? e['userType'] = '供应商' :
                e['userType'] === 4 ? e['userType'] = '系统用户' : ''
      })
      WizBrowserExport({
        title: str,
        sheetName: '系列化关注记录',
        columns: columnDefs.filter((_, index) => index),
        rows: seriesFollowList,
        filename: '系列化关注记录.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  _exportStudyDetailFile(nextProps, nextState, key) {
    let title = nextProps?.apis?.exportStudyDetail?.payload?.apiParams?.name
    if (title) {
      title = title + "-"
    }
    let response = nextProps[key]
    const blob = response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = title + '系列化课程学习明细.xls';

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);
  }

  _exportStudyReportFile(nextProps, nextState, key) {
    let title = nextProps?.apis?.exportStudyReport?.payload?.apiParams?.name
    if (title) {
      title = title + "-"
    }
    let response = nextProps[key]
    const blob = response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = title + '系列化课程学习统计.xls';

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);
  }


  /**
   * 下载
   * @param {*} nextProps
   * @param {*} nextState
   * @param {*} key
   */
  _downloadFile(nextProps, nextState, key) {
    let {success, data, msg} = nextProps[key]
    if (success && data) {
      let {fileId, fileOriginalName, fileUploadStatus} = data;
      let url = getOssFilePath(fileId);
      if (url && fileUploadStatus) {
        const win = window.open(url);
        win.focus();
        return true
      } else {
        Wizmessage.warning('文件还未上传成功，请稍后')
      }
    } else {
      wizNotice.error(msg || '获取文件信息失败,请稍后再试')
      return false;
    }
    return true;
  }

  _getBlob(url, cb) {
    let xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = function () {
      if (xhr.status === 200) {
        cb(xhr.response)
      }
    }
    xhr.send()
  }

  _saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      log.info('进来了1');
      navigator.msSaveBlob(blob, filename);
    } else {
      log.info('进来了2');
      let link = document.createElement('a');
      let body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.target='_blank';
      link.download = filename;
      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        export: this._handleFile,
        updateStatus: this._handleCMD,
        exportFollowRecord: this._handleFollowFile,
        // exportStudyDetail: handleExport.bind(this, {title: '系列化课程学习明细报表', column: []}),
        // exportStudyReport: handleExport.bind(this, {title: '系列化课程学习统计报表', column: []}),
        exportStudyDetail: this._exportStudyDetailFile,
        exportStudyReport: this._exportStudyReportFile,
        getFileInfoByFileId: this._downloadFile.bind(this),
      },

    })
    return <WizReduxTemplate {..._reduxTemplateCofig}  />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(SeriesProgramList);
